module.exports = __webpack_public_path__ + "assets/apply-logo.1197c9b9.png";